<template>
  <div class="space-wrapper">
    <div class="space-title">我的作品</div>
    <div class="space-body">
      <div class="space-tab">
        <ul class="tab-list">
          <li 
          v-for="(item,ind) in tabList" 
          :key="ind" 
          :class="tabKey == item.key?'tab-item active':'tab-item'"
          @click="onTabChange(item.key)"
          >
          
            <a>{{item.tab}} {{item.key === 'zuopin' ? "("+total.user_ppt_total+")":item.key === 'sucai' ? "("+total.user_material_total+")":"("+total.recycled_total+")"}}</a>
          </li>
        </ul>
      </div>
      <div class="space-opeate">
        <div class="cascade-select" v-if="tabKey === 'zuopin'" style="display:none;">
        <Dropdown>
          <a class="ant-dropdown-link" :trigger="['click']">
            全部作品
            <svg-icon name="arrow_b" width="10px" height="6px"></svg-icon>
          </a>
          <template #overlay>
            <Menu>
              <MenuItem>演示PPT</MenuItem>
              <MenuItem>求职简历</MenuItem>
              <SubMenu key="test" title="营销海报">
                <MenuItem>手机海报</MenuItem>
                <MenuItem>竖版海报</MenuItem>
              </SubMenu>
            </Menu>
          </template>
        </Dropdown>

        </div>
        <div class="cascade-select" v-if="tabKey === 'zuopin'">
        <Dropdown>
          <a class="ant-dropdown-link" :trigger="['click']">
            {{currOrder?'最近修改':'最近创建'}}
            <svg-icon name="arrow_b" width="10px" height="6px"></svg-icon>
          </a>
          <template #overlay>
            <Menu>
              <MenuItem @click="onOrder('modifyDateDesc')">最近修改</MenuItem>
              <MenuItem @click="onOrder('')">最近创建</MenuItem>
            </Menu>
          </template>
        </Dropdown>

        </div>
        <div class="sucai-upload" v-if="tabKey === 'sucai'">
          <button class="button" @click="showSucaiUpload"><svg-icon name="upload" width="21px" height="14px" color="#0064fa"></svg-icon>上传素材</button>
        </div>

        <div class="cascade-select" v-if="tabKey === 'recycle'">
        <Dropdown>
          <a class="ant-dropdown-link" :trigger="['click']">
            {{currHistroy}}
            <svg-icon name="arrow_b" width="10px" height="6px"></svg-icon>
          </a>
          <template #overlay>
            <Menu>
              <MenuItem v-for="(item, ind) in histroyList" @click="onChangeHistroy(item)" :key="ind">{{item.tab}}</MenuItem>
            </Menu>
          </template>
        </Dropdown>

        </div>        
        <div class="line" v-if="tabKey === 'zuopin' || tabKey === 'sucai'"></div>
        <Tooltip>
          <template #title>
            <span>批量操作</span>
          </template>
          <div class="batch-operation" :class="isBatchShow?'checked':''" @click="showBatch()">
            <svg-icon name="batch_opeate" width="16px" height="16px"></svg-icon>
          </div>
        </Tooltip>
      </div>
      <div class="space-content">
        <div class="folder-container" v-if="tabKey === 'zuopin'">
          <div class="folder-item" @click="showFolderModal">
            <div class="folder-box">
              <svg-icon name="folder_add" width="20px" height="18px"></svg-icon>
              <p>新建文件夹</p>
            </div>
          </div>

          <div class="folder-item" v-for="(item, ind) in folderList" :key="ind" :class="currFolder.id === item.id?'active':''">
            <div class="folder-box" @click="clickFolder(item)">
              <svg-icon name="folder_default" width="40px" height="35px"></svg-icon>
              <p>{{item.name.length>5?item.name.substring(0,5) + '...':item.name}}</p>
            </div>
            <div class="opeate-box">
                 <Dropdown :trigger="['click']" placement="bottomLeft" :getPopupContainer="
                triggerNode => {
                  return triggerNode.parentNode || document.body;
                }
              ">
                    <button>
                      <svg-icon name="folder_more" width="20px" height="5px"></svg-icon>
                    </button>
                    <template #overlay>
                      <Menu>
                          <MenuItem @click="onRenameFolder(item, ind)">重命名</MenuItem>
                          <MenuItem @click="onDelFolder(item, ind)">删除</MenuItem>
                      </Menu>
                    </template>
                  </Dropdown>
            </div>
          </div>
          <div class="folder-item empty-item"></div><div class="folder-item empty-item"></div><div class="folder-item empty-item"></div><div class="folder-item empty-item"></div><div class="folder-item empty-item"></div>
        </div>
        <div class="folder-bread" v-if="currFolder.id">
          <a @click="showAllFolder" style="color: rgb(51, 51, 51);">全部文件夹</a>><span>{{currFolder.name}}</span>
        </div>
        <div class="batch-container" v-if="isBatchShow">
          <div class="batch-wrap">
            <div class="check"><span @click="onDeleteAllChange(tabKey,isAllChecked)" :class="isAllChecked?'checked':''"><i><svg-icon name="white_right" width="9" height="7"></svg-icon></i>全选</span><span>已选 {{checkedLength}} 个作品</span></div>
    
          </div>
          <div class="batch-wrap">
            <div class="hide" v-if="tabKey === 'zuopin'"><button class="xui-button" :disabled="checkedLength>0?false:true" :class="checkedLength>0?'':'disabled'" @click="showRemoveModal('',0)"><span><svg-icon name="space_remove" width="19" height="16"></svg-icon></span></button></div>
            <div class="hide"><button class="xui-button" @click="onDelete(tabKey)" :disabled="checkedLength>0?false:true" :class="checkedLength>0?'':'disabled'"><span><svg-icon name="space_delete" width="16" height="16"></svg-icon></span></button></div>
            <div class="line"></div>
            <div class="hide"><button class="xui-button hide-button" @click="outDeleteAllChange(tabKey)"><span>退出</span></button></div>
          </div>
        </div>
        <EmptyBox v-if="isEmpty && !spinning"/>
        <div class="template-container" v-if="tabKey === 'zuopin'">
          
          <div :class="{ content: true, 'limit-box': isLimit }">
          <Waterfall
            :list="templateList"
            :breakpoints = breakpoints
            imgSelector= "preview"
            :gutter = "10"
            >
              <template #item="{item, url, index }">
                  <div class="layout-item">
                  <div class="img" :class="templateList[index].checked?'checked':''">
                    <span @click="onDeleteChange(item.ind)" class="delete"><svg-icon name="white_right" width="9" height="7"></svg-icon></span>
                    <div class="info">
                      
                      <button class="edit-button"><a :href="'/editor?code='+ item.id"><svg-icon name="template_edit" width="16px" height="16px"></svg-icon>编辑</a></button>
                      <Dropdown :trigger="['click']" placement="bottomLeft">
                        <button>
                          <svg-icon name="more"></svg-icon>
                        </button>
                        <template #overlay>
                          <Menu>
                              <MenuItem @click="onRenameShow(item)">重命名</MenuItem>
                              <MenuItem @click="showRemoveModal(item,1)">移动</MenuItem>
                              <menuDivider></menuDivider>
                              <MenuItem @click="onCopy(item.id)">创建副本</MenuItem>
                              <MenuItem @click="onDelete(tabKey, item.id)">移入回收站</MenuItem>
                          </Menu>
                        </template>
                      </Dropdown>
                    </div>
                    <div class="tag">
                       <span>{{item.scenes?item.scenes.name:'自定义'}}</span>
                    </div>
                     <LazyImg :url="url" />
                 </div>
                  <div class="title">
                    <span>{{item.title}}</span>
                    <!-- <span>{{slotProp.item.date}}</span> -->
                  </div>
                  </div>
              </template>
              
            </Waterfall >
          </div>
        </div>
        <div class="template-container" v-if="tabKey === 'sucai'">
          <div class="layout-pool">
            <Waterfall
            :list="materialList"
            :breakpoints = breakpoints
            imgSelector= "url"
            :gutter = "10"
            >
              <template #item="{item, url, index }">
                  <div class="layout-item">
                    <div class="img" :class="item.checked?'checked':''">
                    <span @click="onDeleteChange(index)" class="delete"><svg-icon name="white_right" width="9" height="7"></svg-icon></span>
                     <div class="info">
                      
                        <Dropdown :trigger="['click']" placement="bottomLeft">
                          <button>
                            <svg-icon name="more"></svg-icon>
                          </button>
                          <template #overlay>
                            <Menu>
                                <MenuItem @click="onDelete(tabKey, item.id)">删除</MenuItem>
                            </Menu>
                          </template>
                        </Dropdown>
                      </div>
                      <div class="tag">
                        <span>{{item.type}}</span>
                      </div>
                      <LazyImg :url="url" />
                    </div>
                  </div>
              </template>
              
            </Waterfall >
          </div>

        </div>
        <div class="template-container recycle-container" v-if="tabKey === 'recycle'">
          <div class="layout-tab"></div>
          <div :class="{ content: true, 'limit-box': isLimit }" v-if="currHistroy === '作品'">
            <Waterfall
            :list="templateHistroyList"
            :breakpoints = breakpoints
            imgSelector= "preview"
            :gutter = "10"
            >
              <template #item="{item, url, index }">
                  <div class="layout-item">
                <div class="img" :class="templateHistroyList[index].checked?'checked':''">
                    <span @click="onDeleteChange(index)" class="delete"><svg-icon name="white_right" width="9" height="7"></svg-icon></span>
                    <div class="info">
                      <Dropdown :trigger="['click']" placement="bottomLeft">
                        <button>
                          <svg-icon name="more"></svg-icon>
                        </button>
                        <template #overlay>
                          <Menu>
                              <MenuItem @click="onRestore(item.id)">还原</MenuItem>
                              <MenuItem @click="onDelete(tabKey, item.id)">彻底删除</MenuItem>
                          </Menu>
                        </template>
                      </Dropdown>
                    </div>
                    <div class="tag">
                      
                    </div>
                    <LazyImg :url="url" />
                   </div>
                  <div class="title">
                    <span>{{item.title}}</span>
                    <!-- <span>{{slotProp.item.date}}</span> -->
                  </div>
                  </div>
              </template>
              
            </Waterfall >
          </div>
          <div class="layout-pool" v-if="currHistroy === '素材'">
            <Waterfall
            :list="materialHistroyList"
            :breakpoints = breakpoints
            imgSelector= "url"
            :gutter = "10"
            >
              <template #item="{item, url, index }">
                  <div class="layout-item">
                    <div class="img" :class="item.checked?'checked':''">
                    <span @click="onDeleteChange(index)" class="delete"><svg-icon name="white_right" width="9" height="7"></svg-icon></span>
                      <div class="info">
                      
                        <Dropdown :trigger="['click']" placement="bottomLeft">
                          <button>
                            <svg-icon name="more"></svg-icon>
                          </button>
                          <template #overlay>
                            <Menu>
                                <MenuItem @click="onRestore(item.id)">还原</MenuItem>
                                <MenuItem @click="onDelete(tabKey, item.id)">彻底删除</MenuItem>
                            </Menu>
                          </template>
                        </Dropdown>
                      </div>
                      <div class="tag">
                        <span>{{item.type}}</span>
                      </div>
                      <LazyImg :url="url" />
                    </div>
                  </div>
              </template>
              
            </Waterfall >
          </div>
        </div>
        
        <Spin tip="玩命加载中" :spinning="!isEmpty && spinning"></Spin>
        
      </div>
    </div>
    <Modal
          class="create-folder-modal common-modal"
          v-model:visible="imagesVisible"
          :footer="null" 
          :closable="false"
          destroyOnClose
        > 
      <div class="close" @click="closeModal"><svg-icon name="close"></svg-icon></div>
      <div class="modal-container">
        <div class="modal-header">
          <div class="title">{{folderTitle}}</div>
        </div>
        <div class="modal-content">
          <div class="folfer-input"><Input :defaultValue ="folderName" maxLength="50" placeholder="输入文件夹名称..." @change="changeInput" /></div>
        </div>
        <div class="modal-footer">
          <Button size="large" @click="closeModal">取消</Button><Button size="large" type="primary" @click="addFolder">确定</Button>
        </div>
      </div>
    </Modal>
    <Modal
          class="remove-folder-modal create-folder-modal common-modal"
          v-model:visible="removeVisible"
          :footer="null" 
          :closable="false"
          destroyOnClose
        > 
      <div class="close" @click="closeModal"><svg-icon name="close"></svg-icon></div>
      <div class="modal-container">
        <div class="modal-header">
          <div class="title">移动到</div>
        </div>
        <div class="modal-content">
          <div class="tree-main">
            <ul>
              <li :class="currRemoveFolder === -1?'active':''" :key="ind" @click="clickRemoveFolder({id:-1})"><div class="tree-item"><svg-icon name="folder_default" width="20px" height="15px"></svg-icon><span>桌面</span></div></li>
              <li v-for="(item, ind) in folderList" :class="currRemoveFolder === item.id?'active':''" :key="ind" @click="clickRemoveFolder(item)"><div class="tree-item"><svg-icon name="folder_default" width="20px" height="15px"></svg-icon><span>{{item.name}}</span></div></li>
            </ul>
          </div>
        </div>
        <div class="modal-footer">
          <Button size="large" @click="closeModal">取消</Button><Button size="large" type="primary" @click="removeFolder">确定</Button>
        </div>
      </div>
    </Modal>
    <Modal
          class="create-folder-modal common-modal"
          v-model:visible="renameVisible"
          :footer="null" 
          :closable="false"
          destroyOnClose
        > 
      <div class="close" @click="closeModal"><svg-icon name="close"></svg-icon></div>
      <div class="modal-container">
        <div class="modal-header">
          <div class="title">作品重命名</div>
        </div>
        <div class="modal-content">
          <div class="folfer-input"><Input :defaultValue ="templateName" maxLength="50" placeholder="输入作品名称..." @change="changeInputRename" /></div>
        </div>
        <div class="modal-footer">
          <Button size="large" @click="closeModal">取消</Button><Button size="large" type="primary" @click="onRename">确定</Button>
        </div>
      </div>
    </Modal>
    <Modal
          class="upload-modal common-modal"
          v-model:visible="uploadVisible"
          :footer="null" 
          :closable="false"
          destroyOnClose
        > 
      <div class="close" @click="closeModal"><svg-icon name="close"></svg-icon></div>
      <div class="modal-container">
        <div class="modal-header">
          <div class="title">上传素材</div>
        </div>
        <div class="modal-content">
            <UploadDragger
              list-type="picture"
              action="/api/file/save"
              :data = "params"
              :before-upload="beforeUpload"
              :headers= "headers"
              @change="handleChange"
            >
              <svg-icon name="upload" width="47px" height="30px" color="#b4bbcb" style="margin-bottom:10px;"></svg-icon>
              <p class="ant-upload-text">将文件拖动到此处，或  <span style="color:#0064fa;">点击上传</span></p>
              <p class="ant-upload-hint">支持 png、jpg格式，5MB以内</p>
            </UploadDragger>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref, onMounted, onUnmounted } from 'vue'
import { useStore } from '@/store'
import { Slide } from '@/types/slides'
import { message, Modal } from 'ant-design-vue'
// 引入接口
import { SpaceService } from '@/api/space'
import { LazyImg, Waterfall } from 'vue-waterfall-plugin-next'
import 'vue-waterfall-plugin-next/dist/style.css'
import { getFileWidthAndHeight } from '@/utils/image'
export default defineComponent({
  name: 'Template',
  components: {
    Waterfall,LazyImg
  },
  setup() {
    const store = useStore()
    const templates = computed<Slide[]>(() => store.getters.templates)
    const tabKey = ref ('zuopin')
    const currHistroy = ref('作品')
    const currRemoveFolder = ref(0)
    const currRemoveTemplate = ref('')
    const currRemoveType = ref(1)
    const currFolder = ref({name: "", id: ''})
    const currOrder = ref('modifyDateDesc')
    const folderId = ref('')
    const folderName = ref ('')
    const folderTitle = ref ('创建文件夹')
    const templateName = ref('')
    const currSlide = ref()
    const imagesVisible = ref(false)
    const removeVisible = ref(false)
    const renameVisible = ref(false)
    const uploadVisible = ref(false)
    const isBatchShow = ref(false)
    const isEmpty = ref(false)
    const spinning = ref(false)
    const over = ref(false)
    const colWidth = ref(280)
    const breakpoints = {
      3000: { // 当屏幕宽度小于等于1200
        rowPerView: 6,
      },
    }
    const tabList = [
      {
        key: 'zuopin',
        tab: '作品',
      },
      {
        key: 'sucai',
        tab: '素材',
      },
      {
        key: 'recycle',
        tab: '回收站',
      },
    ]
    const folderList = ref([])
    const histroyList = [
      {
        key: 'zuopin',
        tab: '作品',
      },
      {
        key: 'sucai',
        tab: '素材',
      }
    ]
    const materialList = ref([])
    const templateList = ref([])
    const checkedMaterialList = ref([])
    const checkedTemplateList = ref([])
    const isAllChecked = ref(false)
    const checkedLength = ref(0)
    const isTemplateAllChecked = ref(false)
    const materialHistroyList = ref([])
    const templateHistroyList = ref([])
    const checkedMaterialHistroyList = ref([])
    const checkedTemplateHistroyList = ref([])
    const pageSize = ref(36)
    const pageNumber = ref(1)
    const pageSum = ref(0)
    const loading = ref(false)
    const total = ref({user_material_total:0,user_ppt_total:0,recycled_total:0})
    const windowResizeListener = () => {
      colWidth.value = (document.getElementsByClassName('space-wrapper')[0].clientWidth / 6) - 12
    }

  
    const isMounted = ref(false)
    const forUpdate = ref(0)
    const isLimit = ref(true)
    onMounted(() => {
      windowResizeListener()
      window.addEventListener('resize', windowResizeListener)
    })
    onUnmounted(() => {
      window.removeEventListener('resize', windowResizeListener)
    })
    
    const onTabChange = (key: any,) => {
      pageSize.value = 36
      pageNumber.value = 1
      pageSum.value = 0
      tabKey.value = key
      checkedMaterialList.value = []
      checkedTemplateList.value = []
      materialHistroyList.value = []
      templateHistroyList.value = []
      materialList.value = []
      templateList.value = []
      folderList.value = []
      isAllChecked.value = false
      checkedLength.value = 0
      currFolder.value = {name: "", id: ''}
      if (tabKey.value === 'sucai') {
        getUserMaterialList()
        checkedMaterialList.value = []
        isAllChecked.value = false
        materialList.value.forEach((item:any) => {
          item.checked = false
        })
      }
      if (tabKey.value === 'zuopin') {
        checkedTemplateList.value = []
        isTemplateAllChecked.value = false
        getFolderList()
        templateList.value.forEach((item:any) => {
          item.checked = false
        })
        reloadTemplateList()
      }
      if (tabKey.value === 'recycle') {
        templateHistroyList.value = []
        currHistroy.value = '作品'
        getTemplateHistroyList()
      }
      isBatchShow.value = false
    }
    const showFolderModal = () => {
      imagesVisible.value = true
      folderName.value = ''
      folderTitle.value = '创建文件夹'
    }
    const showRemoveModal = (slide:any, type:any) => {
      currRemoveTemplate.value = slide.id
      currRemoveType.value = type
      removeVisible.value = true
    }
    const closeModal = () => {
      imagesVisible.value = false
      renameVisible.value = false
      removeVisible.value = false
      uploadVisible.value = false
    }
    const onDelFolder = async (item:any) => {
      const params = {
        folderId:item.id
      }
      const res = await SpaceService.deleteFolder(params)
      if (res.data.state === 2) {
        message.success(res.data.msg)
      }
      else {
        message.error(res.data.msg)
      }
      getFolderList()
    } 
    const addFolder = async () => {
      imagesVisible.value = false
      if (folderTitle.value === '重命名文件夹') {
        const params = {
          id:folderId.value,
          name:folderName.value
        }
        const res = await SpaceService.renameFolder(params)
        if (res.data.state === 2) {
          message.success(res.data.msg)
        }
        else {
          message.error(res.data.msg)
        }
        getFolderList()
      }
      else {
        const params = {
          name:folderName.value,
          parentId:currFolder.value.id
        }
        const res = await SpaceService.addFolder(params)
        if (res.data.state === 2) {
          message.success(res.data.msg)
        }
        else {
          message.error(res.data.msg)
        }
      }

      getFolderList()
    }
    const changeInput = (e: { target: { value: any } }) => {
      folderName.value = e.target.value
    }
    const changeInputRename = (e: { target: { value: any } }) => {
      templateName.value = e.target.value
    }
    const onRenameFolder = (item: any) => {
      imagesVisible.value = true
      folderName.value = item.name
      folderTitle.value = '重命名文件夹'
      folderId.value = item.id

    }
    const getMaterialHistroyList = async () => {
      const params = {
        pageSize:pageSize.value,
        pageNumber:pageNumber.value
      }
      const res = await SpaceService.getMaterialHistroyList(params)
      materialHistroyList.value = materialHistroyList.value.concat(res.data.data)
      pageSum.value = res.data.pageSum
      res.data.data.forEach((item:any) => {
        item.checked = false
      })
      if (materialHistroyList.value.length <= 0) {
        isEmpty.value = true
        spinning.value = false
      }
      else {
        isEmpty.value = false
        spinning.value = false
      }
    }
    const getTemplateHistroyList = async () => {
      const params = {
        pageSize:pageSize.value,
        pageNumber:pageNumber.value
      }
      const res = await SpaceService.getTemplateHistroyList(params)
      templateHistroyList.value = templateHistroyList.value.concat(res.data.data)
      res.data.data.forEach((item:any, ind:number) => {
        item.checked = false
        item.ind = ind
        if (item.preview === null || item.preview === 'null') {
          item.preview = 'http://file.101dao.com/files/upload/material_file/202205/2c2dba4d-4d8c-4887-83d7-9a1d4cdc4e68.png'
        }
      })
      if (templateHistroyList.value.length <= 0) {
        isEmpty.value = true
        spinning.value = false
      }
      else {
        isEmpty.value = false
        spinning.value = false
      }
    }    
    const getUserMaterialList = async () => {
      const params = {
        pageSize:pageSize.value,
        pageNumber:pageNumber.value
      }
      const res = await SpaceService.getUserMaterialList(params)
      res.data.data.forEach((item:any) => {
        item.thumbUrl = item.url
        item.uid = item.id
        item.status = 'done'
        item.checked = false
      })
      materialList.value = materialList.value.concat(res.data.data)
      pageSum.value = res.data.pageSum
      if (materialList.value.length <= 0) {
        isEmpty.value = true
        spinning.value = false
      }
      else {
        isEmpty.value = false
        spinning.value = false
      }
    }
    const getUserTemplateList = async () => {
      const params = {
        pageSize:pageSize.value,
        pageNumber:pageNumber.value,
        folderId:currFolder.value.id || -1,
        orderType:currOrder.value
      }
      const res = await SpaceService.getUserTemplateList(params)
      templateList.value = templateList.value.concat(res.data.data)
      templateList.value.forEach((item:any,ind:number) => {
        item.checked = false
        item.ind = ind
        if (item.preview === null || item.preview === 'null') {
          item.preview = 'http://file.101dao.com/files/upload/material_file/202205/2c2dba4d-4d8c-4887-83d7-9a1d4cdc4e68.png'
        }
      })
      pageSum.value = res.data.pageSum
      if (templateList.value.length <= 0) {
        isEmpty.value = true
        spinning.value = false
      }
      else {
        isEmpty.value = false
        spinning.value = false
      }
    }    
    const onDeleteChange = (ind: any) => {
      isBatchShow.value = true
      if (tabKey.value === 'sucai') {
        checkedMaterialList.value = []
        materialList.value.forEach((item:any, index) => {
          if (index === ind) {
            item.checked = !item.checked
            
          }
          if (item.checked) {
            checkedMaterialList.value.push(item.id as never)
          }
        })
        checkedLength.value = checkedMaterialList.value.length
      }
      if (tabKey.value === 'zuopin') {
        checkedTemplateList.value = []
        templateList.value.forEach((item:any, index: any) => {
          if (index === ind) {
            item.checked = !item.checked
          }
          if (item.checked) {
            checkedTemplateList.value.push(item.id as never)
          }
        })

        checkedLength.value = checkedTemplateList.value.length
      }
      if (tabKey.value === 'recycle') {
        if (currHistroy.value === '作品') {
          checkedTemplateHistroyList.value = []
          templateHistroyList.value.forEach((item:any, index: any) => {
            if (index === ind) {
              item.checked = !item.checked
              
            }
            if (item.checked) {
              checkedTemplateHistroyList.value.push(item.id as never)
            }
          })
          checkedLength.value = checkedTemplateHistroyList.value.length
        }
        if (currHistroy.value === '素材') {
          checkedMaterialHistroyList.value = []
          materialHistroyList.value.forEach((item:any, index: any) => {
            if (index === ind) {
              item.checked = !item.checked
              
            }
            if (item.checked) {
              checkedMaterialHistroyList.value.push(item.id as never)
            }
          })
          checkedLength.value = checkedMaterialHistroyList.value.length
        }

      }
    }
    const onDeleteAllChange = (type:any, state: any) => {
      if (type === 'sucai') {
        checkedMaterialList.value = []
        if (!state) {
          materialList.value.forEach((item:any) => {
            if (checkedMaterialList.value.length < materialList.value.length) {
              item.checked = true
              isAllChecked.value = true
            }
            
            if (item.checked) {
              checkedMaterialList.value.push(item.id as never)
            }
          })
          
        }
        else {
          materialList.value.forEach((item:any) => {
            item.checked = false
            isAllChecked.value = false
          })
        }
        checkedLength.value = checkedMaterialList.value.length
      }
      if (type === 'zuopin') {

        checkedTemplateList.value = []
        if (!state) {
          templateList.value.forEach((item:any) => {
            if (checkedTemplateList.value.length < templateList.value.length) {
              item.checked = true
              isAllChecked.value = true
            }
            
            if (item.checked) {
              checkedTemplateList.value.push(item.id as never)
            }
          })
        }
        else {
          templateList.value.forEach((item:any) => {
            item.checked = false
            isAllChecked.value = false
          })
        } 
        checkedLength.value = checkedTemplateList.value.length
        windowResizeListener()
      }
      if (type === 'recycle') {
        if (currHistroy.value === '作品') {
          checkedTemplateHistroyList.value = []
          if (!state) {
            templateHistroyList.value.forEach((item:any) => {
              if (checkedTemplateHistroyList.value.length < templateHistroyList.value.length) {
                item.checked = true
                isAllChecked.value = true
              }
              
              if (item.checked) {
                checkedTemplateHistroyList.value.push(item.id as never)
              }
            })
          }
          else {
            templateHistroyList.value.forEach((item:any) => {
              item.checked = false
              isAllChecked.value = false
            })
          } 
          checkedLength.value = checkedTemplateHistroyList.value.length
        }
        if (currHistroy.value === '素材') {
          checkedMaterialHistroyList.value = []
          if (!state) {
            materialHistroyList.value.forEach((item:any) => {
              if (checkedMaterialHistroyList.value.length < materialHistroyList.value.length) {
                item.checked = true
                isAllChecked.value = true
              }
              
              if (item.checked) {
                checkedMaterialHistroyList.value.push(item.id as never)
              }
            })
          }
          else {
            materialHistroyList.value.forEach((item:any) => {
              item.checked = false
              isAllChecked.value = false
            })
          } 
          checkedLength.value = checkedMaterialHistroyList.value.length
        }
      }
    }
    const outDeleteAllChange = () => {
      isBatchShow.value = false
      if (tabKey.value === 'sucai') {
        checkedMaterialList.value = []
        isAllChecked.value = false
        materialList.value.forEach((item:any) => {
          item.checked = false
        })
      }
      if (tabKey.value === 'zuopin') {
        checkedTemplateList.value = []
        isTemplateAllChecked.value = false
        templateList.value.forEach((item:any) => {
          item.checked = false
        })
      }
      if (tabKey.value === 'recycle') {
        checkedTemplateHistroyList.value = []
        isTemplateAllChecked.value = false
        templateHistroyList.value.forEach((item:any) => {
          item.checked = false
        })
        checkedMaterialHistroyList.value = []
        isAllChecked.value = false
        materialHistroyList.value.forEach((item:any) => {
          item.checked = false
        })
      }
    }
    const onRestore = async (id: string) => {
      const params = {
        ids:''
      }
      if (currHistroy.value === '素材') {
        if (id) {
          params.ids = id
        }
        else {
          params.ids = checkedMaterialHistroyList.value.join(',')
        }
        const res = await SpaceService.showMaterial(params)  
        if (res.data.state === 2) {
          materialHistroyList.value = []
          pageNumber.value = 1
          getMaterialHistroyList()
          message.success(res.data.msg)
        }
        else {
          message.error(res.data.msg)
        }   
        
      }
      if (currHistroy.value === '作品') {
        if (id) {
          params.ids = id
        }
        else {
          params.ids = checkedTemplateHistroyList.value.join(',')
        }
        const res = await SpaceService.showTemplate(params)  
        if (res.data.state === 2) {
          getTemplateHistroyList()
          message.success(res.data.msg)
        }
        else {
          message.error(res.data.msg)
        }  
      }
    }
    const onDelete = (key: string, id: string) => {
      Modal.confirm({
        title: '删除提示',
        content: key === 'recycle' ? '删除资源后将无法重新找回，请谨慎操作！' : '是否确定要转移到回收站？',
        okText:'确定删除',
        cancelText:'取消',
        onOk() {

          return new Promise((resolve, reject) => {
            const res = confirmOnOk(resolve, reject, key, id)
            return res
          })
        },
      })
    }
    const confirmOnOk = async (resolve:any, reject:any, key:string, id:string) => {
      const params = {
        ids:''
      }
      if (key === 'sucai') {
        if (id) {
          params.ids = id
        }
        else {
          params.ids = checkedMaterialList.value.join(',')
        }
        
        const res = await SpaceService.hideMaterial(params)  
        if (res.data.state === 2) {
          resolve()
          outDeleteAllChange()
          materialList.value = []
          pageNumber.value = 1
          getUserMaterialList()
          getToatl()
          message.success(res.data.msg)
        }
        else {
          message.error(res.data.msg)
        }  
      }
      if (key === 'zuopin') {
        if (id) {
          params.ids = id
        }
        else {
          params.ids = checkedTemplateList.value.join(',')
        }
        const res = await SpaceService.hideTemplate(params)  
        if (res.data.state === 2) {
          resolve()
          outDeleteAllChange()
          reloadTemplateList()
          getTemplateHistroyList()
          getToatl()
          message.success(res.data.msg)
        }
        else {
          message.error(res.data.msg)
        }  
      }
      if (key === 'recycle') {
        if (currHistroy.value === '素材') {
          if (id) {
            params.ids = id
          }
          else {
            params.ids = checkedMaterialHistroyList.value.join(',')
          }
          const res = await SpaceService.delMaterial(params)  
          if (res.data.state === 2) {
            resolve()
            materialHistroyList.value = []
            pageNumber.value = 1
            getMaterialHistroyList()
            outDeleteAllChange()
            getToatl()
            message.success(res.data.msg)
          }
          else {
            message.error(res.data.msg)
          }  
        }
        if (currHistroy.value === '作品') {
          if (id) {
            params.ids = id
          }
          else {
            params.ids = checkedTemplateHistroyList.value.join(',')
          }
          const res = await SpaceService.delTemplate(params)  
          if (res.data.state === 2) {
            resolve()
            templateHistroyList.value = []
            pageNumber.value = 1
            outDeleteAllChange()
            getTemplateHistroyList()
            getToatl()
            message.success(res.data.msg)
          }
          else {
            message.error(res.data.msg)
          }  
        }
      }
    }
    const onChangeHistroy = (data:any) => {
      currHistroy.value = data.tab
      outDeleteAllChange()
      if (data.key === 'sucai') {
        materialHistroyList.value = []
        pageNumber.value = 1
        getMaterialHistroyList()
      }
      else {
        templateHistroyList.value = []
        pageNumber.value = 1
        getTemplateHistroyList()
      }
      
    }
    const showBatch = () => {
      isBatchShow.value = !isBatchShow.value
    }
    const getFolderList = async () => {
      const params = {
        parentId:currFolder.value.id,
      }
      const res = await SpaceService.folderList(params)
      folderList.value = res.data.data
    }
    const getToatl = async () => {
      const params = {
      }
      const res = await SpaceService.pptTotal(params)
      total.value = res.data.data
    }
    const clickRemoveFolder = (item:any) => {
      currRemoveFolder.value = item.id
    }
    const removeFolder = async () => {
      if (currRemoveFolder.value < -1) {
        message.error('请选择要移动的文件夹')
        return
      }
      if (currRemoveType.value === 1) {
        const params = {
          folderId:currRemoveFolder.value,
          contentIds:currRemoveTemplate.value
        }
        const res = await SpaceService.movesFolder(params)
        if (res.data.state === 2) {
          message.success('移动成功')
          outDeleteAllChange()
          getFolderList()
          reloadTemplateList()
          removeVisible.value = false
        }
        else {
          message.error(res.data.msg)
        }
      }
      else {
        const params = {
          folderId:currRemoveFolder.value,
          contentIds:checkedTemplateList.value.join(',')
        }
        const res = await SpaceService.movesFolder(params)
        if (res.data.state === 2) {
          message.success('移动成功')
          outDeleteAllChange()
          getFolderList()
          reloadTemplateList()
          removeVisible.value = false
        }
        else {
          message.error(res.data.msg)
        }
      }

    }
    const clickFolder = (item:any) => {
      currFolder.value = item
      reloadTemplateList()
      getFolderList()
    }
    const showAllFolder = () => {
      currFolder.value = {name: "", id: ''}
      getFolderList()
      reloadTemplateList()
    }
    const reloadTemplateList = () => {
      templateList.value = []
      pageNumber.value = 1
      over.value = false
      getUserTemplateList()
    }

    const onOrder = (type:any) => {
      currOrder.value = type
      reloadTemplateList()
    }
    const onCopy = async (id:any) => {
      const params = {
        id:id
      }
      const key = 'updatable'
      message.loading({content:'复制内容中..', key})
      const res = await SpaceService.copyTemplate(params)
      if (res.data.state === 2) {
        message.success({content:'创建副本成功', key})
        reloadTemplateList()
        getToatl()
      }
      else {
        message.error(res.data.msg)
      }
    }
    const onRenameShow = (slide:any) => {
      currSlide.value = slide
      renameVisible.value = true
      templateName.value = slide.title

    }
    const onRename = async () => {
      const params = {
        id:currSlide.value.id,
        name:templateName.value
      }
      const key = 'updatable'
      message.loading({content:'修改名称中..', key})
      const res = await SpaceService.renameTemplate(params)
      if (res.data.state === 2) {
        message.success({content:'修改成功', key})
        reloadTemplateList()
      }
      else {
        message.error(res.data.msg)
      }
      renameVisible.value = false
    }
    const onScroll = () => {

      if (
        document.documentElement.scrollTop + document.documentElement.clientHeight >=
        document.documentElement.scrollHeight
      ) {
      
        if (pageNumber.value >= pageSum.value) {
          return false
        }
        
        pageNumber.value++
        spinning.value = true
        if (tabKey.value === 'zuopin') {
          getUserTemplateList()
        }
        if (tabKey.value === 'sucai') {
          getUserMaterialList()
        }
        if (tabKey.value === 'recycle') {
          if (currHistroy.value === '素材') {
            getMaterialHistroyList()
          }
        }
      }
    }
    const showSucaiUpload = () => {
      uploadVisible.value = true
    }
    const params = ref()
    const headers = ref({
      token: computed(() => store.state.token) || ''
    })
    
    let hide:any = null
    const handleChange = (info: any) => {
      if (info.file.status !== 'uploading') {
        closeModal()
      }
      if (info.file.status === 'done') {
        setTimeout(hide, 1)
        setTimeout(message.success(`${info.file.name} 上传成功！`), 500)
        materialList.value = []
        pageNumber.value = 1
        getUserMaterialList()

      }
      else if (info.file.status === 'error') {
        setTimeout(hide, 1)
        message.error(`${info.file.name} 上传失败！`)
      }
    }
    const beforeUpload = (file: any) => {
      hide = message.loading('正在上传中..', 0)
      let type = 'png'
      if (file.type === 'image/jpeg') {
        type = 'jpg'
      }
      else if (file.type === 'image/png') {
        type = 'png'
      }
      else if (file.type === 'image/gif') {
        type = 'gif'
      }
      else {
        setTimeout(hide, 1)
        message.error('暂不支持的格式')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isLt2M) {
        setTimeout(hide, 1)
        message.error('上传文件大小不能超过 5MB!')
        return false
      }
      params.value = {
        height:'',
        width:'',
        type: type,
      }
      return getFileWidthAndHeight(file, 5000, 5000, hide)
      // const res = await UploadService.userMaterial(params)
    }
    onMounted(getUserTemplateList)
    window.addEventListener('scroll', onScroll)
    getFolderList()
    getToatl()
    return {
      folderTitle,
      folderName,
      tabKey,
      tabList,
      folderList,
      templates,
      materialList,
      imagesVisible,
      removeVisible,
      uploadVisible,
      showRemoveModal,
      templateList,
      onTabChange,
      closeModal,
      showFolderModal,
      addFolder,
      onDelFolder,
      onRenameFolder,
      changeInput,
      value: ref<string[]>([]),
      onDeleteChange,
      onDeleteAllChange,
      isAllChecked,
      checkedLength,
      isTemplateAllChecked,
      checkedTemplateList,
      checkedMaterialList,
      templateHistroyList,
      materialHistroyList,
      outDeleteAllChange,
      onDelete,
      onRestore,
      onChangeHistroy,
      histroyList,
      currHistroy,
      showBatch,
      isBatchShow,
      isEmpty,
      spinning,
      clickRemoveFolder,
      currRemoveFolder,
      removeFolder,
      currFolder,
      clickFolder,
      showAllFolder,
      currOrder,
      onOrder,
      onCopy,
      templateName,
      changeInputRename,
      onRenameShow,
      onRename,
      renameVisible,
      isLimit,
      isMounted,
      forUpdate,
      loading,
      over,
      colWidth,
      total,
      showSucaiUpload,
      handleChange,
      beforeUpload,
      params,
      headers,
      breakpoints
    }
  },
})
</script>

<style lang="scss">
.waterfall {
    width: 100%;
    min-width: 1200px;
}

.line {
  width: 1px;
  height: 18px;
  background-color: #b8bcc1;
  margin-right: 20px;
}
.sucai-upload {
  color: $themeColor;
  .button {
    display: flex;
    align-items: center;
    margin-right: 10px;
    .svg-icon {
      margin-right: 4px;
    }
  }
}
.sucai-upload:hover {
  opacity: .8;
  cursor: pointer;
}
.space-title {
  font-size: 18px;
  color: #1a1a1a;
  font-weight: bold;
  padding: 15px 10px 30px 10px;
}
.space-body {
  position: relative;
}
.space-tab {
  padding: 0 10px;
  .tab-list {
    display: flex;
    border-bottom: 1px solid #e3e7ed;
    li {
      margin: 0 25px 0 0;
    }
    a {
      position: relative;
      color: #363636;
      height: 36px;
      line-height: 36px;
      display: block;
      transition: all cubic-bezier(0.445, 0.05, 0.55, 0.95);
    }
    a:hover {
      color: #000;
    }
    a::after {
      left: 0;
      bottom: 0;
      position: absolute;
      content: "";
      width: 0px;
      height: 3px;
      background: $themeColor;
      box-shadow: 0px 4px 6px 0px rgba($color: $themeColor, $alpha: 0.4);
      transition: width .3s;
    }
    .active a::after {
      width: 100%;
    }
    .active a {
      font-weight: bold;
    }
  }
}
.space-opeate {
  position: absolute;
  top: 12px;
  right: 0;
  display: flex;
  .cascade-select {
    margin-right: 20px;
  }
  .ant-dropdown-link {
    color: #555a60;
    height: 25px;
    display: block;
  }

  .cascade-select:hover {
    .ant-dropdown-link {
      color: $themeColor;
    }
  }
  .batch-operation {
    cursor: pointer;
    .svg-icon {
      color: #525d6e;
    }
  }
  .batch-operation:hover,.batch-operation.checked {
    .svg-icon {
      color: $themeColor;
    }
  }
}
.space-content {
  min-height: 1500px;
  .folder-container {
    padding: 0 10px;
    margin: 20px 0 0 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    .folder-item {
      display: flex;
      width: 160px;
      height: 70px;
      margin: 0 15px 15px 0;
      border-radius: 4px;
      background: #f9f9fc;
      align-items: center;
      text-align: center;
      justify-content: center;
      transition: all .4s;
      cursor: pointer;
      position: relative;
      .folder-box {
        text-align: center;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0 0 0 15px;
        .svg-icon {
          margin: 16px 8px 15px 0;
        }
        p {
          color: #000;
          height: 10px;
        }
      }
      .opeate-box {
        position: absolute;
        top: 6px;
        right: 4px;
        opacity: 0;
        button {
          cursor: pointer;
          color: #666;
        }
        button:hover {
          color: #000;
        }
      }
    }
    .folder-item:hover {
      background: #ededf1;
    }
    .folder-item:hover .opeate-box {
      opacity: 1;
    }
    .empty-item {
      background: transparent;
      height: 0px;
    }
  }
  .folder-bread {
    padding: 0 10px;
    margin-top: 30px;
    font-size: 12px;
  }
  .template-container {
    margin-top: 10px;
    .layout-pool {
      column-count: auto;
    }
    .layout-item {
      box-sizing: border-box;
      .img {
        position: relative;
        break-inside: avoid;
        box-sizing: border-box;
        padding: 0;
        margin-bottom: 6px;
        cursor: pointer;
        background: url(data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAABkAAD/4QMvaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjYtYzE0NSA3OS4xNjM0OTksIDIwMTgvMDgvMTMtMTY6NDA6MjIgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE5IChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpCQTdDNUI3MTNDOEMxMUVDOUYwQTk2MjZBNzUxRUQyRCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpCQTdDNUI3MjNDOEMxMUVDOUYwQTk2MjZBNzUxRUQyRCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkJBN0M1QjZGM0M4QzExRUM5RjBBOTYyNkE3NTFFRDJEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkJBN0M1QjcwM0M4QzExRUM5RjBBOTYyNkE3NTFFRDJEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+/+4AJkFkb2JlAGTAAAAAAQMAFQQDBgoNAAAE6wAABSoAAAVlAAAFkP/bAIQAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQICAgICAgICAgICAwMDAwMDAwMDAwEBAQEBAQECAQECAgIBAgIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMD/8IAEQgADAAMAwERAAIRAQMRAf/EAIwAAAMBAAAAAAAAAAAAAAAAAAAGBwkBAQAAAAAAAAAAAAAAAAAAAAAQAAIDAQAAAAAAAAAAAAAAAAQFACAVNREAAQIEBgMAAAAAAAAAAAAAAhIDAAETBBARQSKDo7PTNBIBAAAAAAAAAAAAAAAAAAAAIBMAAgEFAAAAAAAAAAAAAAAAIAERECFRkeH/2gAMAwEAAhEDEQAAAdVRFAup/9oACAEBAAEFAjDBmA2MyibpT//aAAgBAgABBQKn/9oACAEDAAEFAqf/2gAIAQICBj8CH//aAAgBAwIGPwIf/9oACAEBAQY/AnLS0cq3DqKbaDBSDFwtzggEsgCesfP2se2Lfl8DuH//2gAIAQEDAT8h3j6G/wBJdJjIHHf/2gAIAQIDAT8hD//aAAgBAwMBPyEP/9oADAMBAAIRAxEAABCAD//aAAgBAQMBPxDgAQbet8KWSdTDP//aAAgBAgMBPxAP/9oACAEDAwE/EA//2Q==) 0 0;
        border-radius: 4px;
        img {
          width: 100%;
          border-radius: 4px;
          border: 1px solid #e8eaec;
        }
        .delete {
          position: absolute;
          width: 16px;
          height: 16px;
          background: #171717;
          border: 1px solid #fff;
          top: 5px;
          left: 5px;
          opacity: 0;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          .svg-icon {
            opacity: 0;
          }
        }
        .info {
          position: absolute;
          right: 0;
          top: 40%;
          width: 100%;
          display: flex;
          justify-content: center;
          z-index: 2;
          button {
            background: #fff;
            display: flex;
            height: 40px;
            width: 40px;
            border-radius: 40px;
            align-items: center;
            cursor: pointer;
            opacity: 0;
            color: #4f4f50;
            margin: 0 5px;
            a {
              color: #000;
            }
            .svg-icon {
              margin-left: 2px;
            }
          }
          button:hover {
            background: $themeColor;
            color: #fff;
            a {
              color: #fff;
            }
          }
          .edit-button {
            width: 110px;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #000;
            .svg-icon {
              margin: -5px 3px 0 0;
            }
          }
        }
        .tag {
          position: absolute;
          right: 0;
          bottom: 0;
          padding: 10px;
          span {
            background: rgba(0, 0, 0, 0.6);
            color: #fff;
            padding: 0 15px;
            height: 25px;
            line-height: 25px;
            border-radius: 25px;
            display: inline-block;
            font-size: 10px;
          }
        }
      }
      .title {
        display: flex;
        justify-content:left;
        color: #595c62;
        margin-bottom: 10px;
        span {
          white-space:nowrap;
          overflow:hidden;
          text-overflow:ellipsis;
        }
        span:last-child {
          font-size: 14px;
          color: #4e4e4e;
          width: 100%;
          text-align: left;
        }
      }
      .img:hover::after {
        opacity: .4;
      }
      .img:hover button {
        opacity: 1;
      }
      .img:hover .delete {
        opacity: 1;
      }
      .img.checked {
        border: 2px solid $themeColor;
        .delete {
          opacity: 1;
          background-color: $themeColor;
          .svg-icon {
            opacity: 1;
          }
        }
      }
      .img::after {
        content: " ";
        background: rgba(0, 0, 0, .25);
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        opacity: 0;
        transition: opacity .2s ease;
        z-index: 1;
        pointer-events: none;
      }
    }
  }
  .batch-container {
    margin-top: 20px;
    height: 48px;
    padding: 0 15px;
    background-color: #f9f9fc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .batch-wrap {
      display: flex;
      align-items: center;
      .check {
        display: flex;
        align-items: center;
        cursor: pointer;
        i {
          width: 16px;
          height: 16px;
          background: #fff;
          border: 1px solid #c2c2c2;
          margin-right: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
         .svg-icon {
            opacity: 0;
          }
        }
        span {
          display: flex;
          align-items: center;
          margin-right: 30px;
        }
      }
      .checked {
        i {
          background: $themeColor;
          border: 1px solid $themeColor;
         .svg-icon {
            opacity: 1;
          }
        }
      }
      .hide {
        margin: 0 0 0 10px;
        .svg-icon {
          color: #ff0000;
          opacity: .8;
        }
        .disabled {
          .svg-icon {
            opacity: .3;
          }
          .svg-icon:hover {
            opacity: .3;
          }
        }
        .icon-space_remove {
          color: $themeColor;
        }
        .svg-icon:hover {
          opacity: 1;
        }
        .hide-button {
          color: $themeColor;
        }
      }
      .line {
        margin: 0;
        margin-left: 15px;
      }
    }
  }
  .layout-item {
    box-sizing: border-box;
    .img {
      position: relative;
      break-inside: avoid;
      box-sizing: border-box;
      padding: 0;
      margin-bottom: 6px;
      cursor: pointer;
      background: url(data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAABkAAD/4QMvaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjYtYzE0NSA3OS4xNjM0OTksIDIwMTgvMDgvMTMtMTY6NDA6MjIgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE5IChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpCQTdDNUI3MTNDOEMxMUVDOUYwQTk2MjZBNzUxRUQyRCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpCQTdDNUI3MjNDOEMxMUVDOUYwQTk2MjZBNzUxRUQyRCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkJBN0M1QjZGM0M4QzExRUM5RjBBOTYyNkE3NTFFRDJEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkJBN0M1QjcwM0M4QzExRUM5RjBBOTYyNkE3NTFFRDJEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+/+4AJkFkb2JlAGTAAAAAAQMAFQQDBgoNAAAE6wAABSoAAAVlAAAFkP/bAIQAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQICAgICAgICAgICAwMDAwMDAwMDAwEBAQEBAQECAQECAgIBAgIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMD/8IAEQgADAAMAwERAAIRAQMRAf/EAIwAAAMBAAAAAAAAAAAAAAAAAAAGBwkBAQAAAAAAAAAAAAAAAAAAAAAQAAIDAQAAAAAAAAAAAAAAAAQFACAVNREAAQIEBgMAAAAAAAAAAAAAAhIDAAETBBARQSKDo7PTNBIBAAAAAAAAAAAAAAAAAAAAIBMAAgEFAAAAAAAAAAAAAAAAIAERECFRkeH/2gAMAwEAAhEDEQAAAdVRFAup/9oACAEBAAEFAjDBmA2MyibpT//aAAgBAgABBQKn/9oACAEDAAEFAqf/2gAIAQICBj8CH//aAAgBAwIGPwIf/9oACAEBAQY/AnLS0cq3DqKbaDBSDFwtzggEsgCesfP2se2Lfl8DuH//2gAIAQEDAT8h3j6G/wBJdJjIHHf/2gAIAQIDAT8hD//aAAgBAwMBPyEP/9oADAMBAAIRAxEAABCAD//aAAgBAQMBPxDgAQbet8KWSdTDP//aAAgBAgMBPxAP/9oACAEDAwE/EA//2Q==) 0 0;
      border-radius: 4px;
      img {
        width: 100%;
        border-radius: 4px;
        border: 1px solid #e8eaec;
      }
      .delete {
        position: absolute;
        width: 16px;
        height: 16px;
        background: #171717;
        border: 1px solid #fff;
        top: 5px;
        left: 5px;
        opacity: 0;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        .svg-icon {
          opacity: 0;
        }
      }
      .info {
        position: absolute;
        right: 0;
        top: 40%;
        width: 100%;
        display: flex;
        justify-content: center;
        z-index: 2;

        button {
          background: #fff;
          display: flex;
          height: 40px;
          width: 40px;
          border-radius: 40px;
          align-items: center;
          cursor: pointer;
          opacity: 0;
          color: #4f4f50;
          margin: 0 5px;
          a {
            color: #000;
          }
          .svg-icon {
            margin-left: 2px;
          }
        }
        button:hover {
          background: $themeColor;
          color: #fff;
          a {
            color: #fff;
          }
        }
        .edit-button {
          width: 110px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #000;
          .svg-icon {
            margin: -5px 3px 0 0;
          }
        }
      }
      .tag {
        position: absolute;
        right: 0;
        bottom: 0;
        padding: 10px;
        span {
          background: rgba(0, 0, 0, 0.6);
          color: #fff;
          padding: 0 15px;
          height: 25px;
          line-height: 25px;
          border-radius: 25px;
          display: inline-block;
          font-size: 12px;
        }
      }
    }
    .title {
      display: flex;
      justify-content: space-between;
      color: #595c62;
      span {
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
      }
      span:last-child {
        font-size: 12px;
        color: #a0a7b1;
        min-width: 130px;
        text-align: right;
      }
    }
    .img:hover::after {
      opacity: .4;
    }
    .img:hover button {
      opacity: 1;
    }
    .img:hover .delete {
      opacity: 1;
    }
    .img.checked {
      border: 2px solid $themeColor;
      .delete {
        opacity: 1;
        background-color: $themeColor;
        .svg-icon {
          opacity: 1;
        }
      }
    }
    .img::after {
      content: " ";
      background: rgba(0, 0, 0, .25);
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      opacity: 0;
      transition: opacity .2s ease;
      z-index: 1;
      pointer-events: none;
    }
  }
}
</style>